import Vue from 'vue'
import Router from 'vue-router'
import NotFound from '@/components/common/NotFound'


import Home from './components/Home'
import IntegratedSearchList from './components/integratedsearch/IntegratedSearchList'
import Notice from './components/notice/Notice'
import NoticeDetail from './components/notice/NoticeDetail'
import Faq from './components/faq/Faq'
import Diag from './components/diag/Diag'
import DiagDetail from './components/diag/DiagDetail'
import Inquiry from './components/inquiry/Inquiry'
import InquiryRegister from "./components/inquiry/InquiryRegister"
import InquiryList from "./components/inquiry/InquiryList"
import InquiryDetail from "./components/inquiry/InquiryDetail"
import QRCodeScanner from './components/inquiry/QRCodeScanner'
import QRCodeUnsupported from './components/inquiry/QRCodeUnsupported'
import Tvapp from './components/tvapp/Tvapp'
import TvappSeller from './components/tvapp/TvappSeller'
import TvappDetail from './components/tvapp/TvappDetail'
import TvappSearch from './components/tvapp/TvappSearch'
import AllApps from './components/tvapp/AllApps'
import AllAppsDetail from './components/tvapp/AllAppsDetail'
import Nation from './components/common/Nation'
import Terms from './components/terms/Terms'
import TermsAuto from './components/terms/TermsAuto'
import TermsTH from './components/terms/TermsTH'
import GA from './components/terms/GA'
import ShopTime from './components/terms/ShopTime'
import Tvod from './components/terms/Tvod'
import BannerLink from './components/common/BannerLink'
import PolicyLink from './components/common/PolicyLink'
import LoginLink from './components/common/LoginLink'
import AdList from './components/common/AdList'
import ClosingRefund from './components/common/ClosingRefund'
import ClosingServiceGuide from './components/common/ClosingServiceGuide'
import Oss from './components/oss/Oss'
import Main from './components/Main'

Vue.use(Router)

export default new Router({
    mode: 'history',
    linkActiveClass: 'active',
    routes: [
        // main
        { 
            name: "main", path: '/main', component: Main,
            children: [
                { name: 'home', path: '/', component: Home },
                { name: 'integratedSearchList', path: 'integrated/search', component: IntegratedSearchList },
                { name: 'notice', path: 'notice', component: Notice },
                { name: 'noticeDetail', path: 'notice/detail', component: NoticeDetail },
                { name: 'faq', path: 'faq', component: Faq },
                { name: 'diag', path: 'diag', component: Diag },
                { name: 'diagDetail', path: 'diag/detail', component: DiagDetail },
                { name: 'inquiry', path: 'inquiry', component: Inquiry },
                { name: 'inquiryRegister', path: 'inquiry/register', component: InquiryRegister, props: true},
                { name: 'inquiryList', path: 'inquiry/list', component: InquiryList, props: true},
                { name: 'inquiryDetail', path: 'inquiry/detail', component: InquiryDetail, props: true},
                { name: 'tvapp', path: 'tvapp', component: Tvapp },
                { name: 'tvappSeller', path: 'tvapp/seller', component: TvappSeller },
                { name: 'tvappDetail', path: 'tvapp/detail', component: TvappDetail },
                { name: 'appSearch', path: 'appSearch', component: TvappSearch },
                { name: 'allapps', path: 'allapps', component: AllApps },
                { name: 'allappsDetail', path: 'allapps/detail', component: AllAppsDetail },
                { name: 'terms', path: 'terms', component: Terms },
                { name: 'termsAuto', path: 'termsAuto', component: TermsAuto },
                { name: 'th_w20', path: 'th_w20', component: Terms },
                { name: 'ga', path: 'ga', component: GA },
                { name: 'shopTime', path: 'shopTime', component: ShopTime },
                { name: 'tvod', path: 'tvod', component: Tvod },
                { name: 'bannerLink', path: 'bannerLink', component: BannerLink },
                { name: 'policyLink', path: 'policyLink', component: PolicyLink },
                { name: 'loginLink', path: 'loginLink', component: LoginLink },
                { name: 'adList', path: 'adList', component: AdList },
                { name: 'closingRefund', path: 'closingRefund', component: ClosingRefund },
                { path: "*", component: NotFound },
            ]
        },
        { 
            name: 'nation', path: '/nation', component: Nation
        },
        {
            name: 'scanner', path: '/scanner', component: QRCodeScanner
        },
        {
            name: 'unsupported', path: '/unsupported', component: QRCodeUnsupported
        },
        {
            name: 'oss', path: '/oss', component: Oss
        },
        {
            name: 'closingServiceGuide', path: '/closingServiceGuide', component: ClosingServiceGuide
        },
        {
            path: '/index.html', redirect: '/main'
        },
        {
            path: '/', redirect: '/main'
        },
        {
            path: "*", component: NotFound
        }
    ]
});
